import axios from "axios"

const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_KEY}`,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 600000,
});

axiosInstance.interceptors.request.use(request => {
  const accessToken = localStorage.getItem('accessToken');
  if (accessToken) {
    request.headers['Authorization'] = `Bearer ${accessToken}`;
  }
  return request;
}, error => {
  return Promise.reject(error);
})

axiosInstance.interceptors.response.use(
  response => response, // Directly return successful responses.
  async error => {
    console.log('error: ', error);
    const originalRequest = error?.config;
    if (error?.response?.status === 403 && !originalRequest?._retry) {
      originalRequest._retry = true; // Mark the request as retried to avoid infinite loops.
      try {
        const refreshToken = localStorage.getItem('refreshToken'); // Retrieve the stored refresh token.
        // Make a request to your auth server to refresh the token.
        const response = await axios.post(`${process.env.REACT_APP_API_KEY}api/auth/refresh-token`, {
          refreshToken,
        });
        console.log('response: ', response);
        const { accessToken } = response?.data;
        // Store the new access and refresh tokens.
        localStorage.setItem('accessToken', accessToken);
        // localStorage.setItem('refreshToken', newRefreshToken);
        // Update the authorization header with the new access token.
        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        return axiosInstance(originalRequest); // Retry the original request with the new access token.
      } catch (refreshError) {
        // Handle refresh token errors by clearing stored tokens and redirecting to the login page.
        console.error('Token refresh failed:', refreshError);
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error); // For all other errors, return the error as is.
  }
);

export default axiosInstance